export const animate = (element, distance, style) => {
    return new Promise((resolve, reject) => {
       
        const getStyle = (el, style) => {
          
            return window.getComputedStyle(el, null)[style];
        };
        cancelAnimationFrame(element.Timer);
     
        const target = distance;

        const handler = () => {
            let current = parseInt(getStyle(element, style).replace('px',''));
         
            let step = (target - current) / 10;

            step = step > 0 ? Math.ceil(step) : Math.floor(step);

            current += step;

            element.style[style] = current + "px";
           
            if (target === current) {
              
                resolve();
            } else {
                element.Timer = requestAnimationFrame(handler)
            }
        };
        handler();
    });


}